import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { Services } from "@/components/Services";
import { Cultures } from "@/components/Cultures";
import { WorldStages } from "@/components/WorldStages";
import { Maestro } from "@/components/Maestro";
import { VideoSection } from "@/components/VideoSection";
import { PlannerBand } from "@/components/PlannerBand";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
    return (
        <main data-testid="landing-page" className="bg-[#08080a] text-[#fafafa]">
            <Header />
            <Hero />
            <TrustStrip />
            <Services />
            <Cultures />
            <WorldStages />
            <Maestro />
            <VideoSection />
            <PlannerBand />
            <EnquiryForm />
            <Footer />
        </main>
    );
}
